<template>
  <div>
    <div class="d-flex mb-4 align-items-center">
      <h3 class="m-0">Base Prices</h3>
      <StripeBtn class="ml-3" @click="openModal(CARRIER_PRIORITY_MODAL)"> Available carriers </StripeBtn>
      <StripeBtn class="ml-3" @click="openModal(EDIT_DMT_FEE_MODAL)"> DMT Fee </StripeBtn>
    </div>
    <BasePriceTable :prices="prices" @update-price="updatePrice" @remove-price="removePrice" />
    <EditDmtFeeModal :id="EDIT_DMT_FEE_MODAL" />
    <CarrierPriorityModal :id="CARRIER_PRIORITY_MODAL" type="base" />
    <PageFooter @save-prices="savePrices" @add-price="addPrice" />
  </div>
</template>

<script lang="ts">
import { computed, defineAsyncComponent, defineComponent, onBeforeUnmount, onMounted } from 'vue'
import { CARRIER_PRIORITY_MODAL, EDIT_DMT_FEE_MODAL, EDIT_PRICE_MODAL } from '@/const/ModalTypes'
import { BASE } from '@/const/PriceTypes'
import { none } from '@/services/Helpers'
import { openModal, registerModals } from '@/services/Modal'
import { addPrice, removePrice, savePrices, updatePrice } from '@/services/Prices/PriceActions'
import { usePricesStore } from '@/store/prices'
import StripeBtn from '@/views/Components/Elements/Buttons/StripeBtn.vue'

export default defineComponent({
  name: 'BasePricePage',
  components: {
    StripeBtn,
    PageFooter: defineAsyncComponent(() => import('@/views/Components/PageParts/PageFooter.vue')),
    BasePriceTable: defineAsyncComponent(() => import('@/views/Staff/BasePrice/BasePriceTable.vue')),
    EditDmtFeeModal: defineAsyncComponent(() => import('@/views/Modals/BasePrice/EditDmtFeeModal.vue')),
    CarrierPriorityModal: defineAsyncComponent(() => import('@/views/Modals/Assignment/CarrierPriorityModal.vue')),
  },
  setup() {
    const pricesStore = usePricesStore()
    const prices = computed(() => pricesStore.prices)

    onMounted(() => {
      registerModals(EDIT_PRICE_MODAL)
      registerModals(EDIT_DMT_FEE_MODAL)
      registerModals(CARRIER_PRIORITY_MODAL)
      pricesStore.setType(BASE)
      pricesStore.setEntityId(null)
      pricesStore.fetch({}).catch(none)
    })

    onBeforeUnmount(() => {
      pricesStore.resetState()
    })

    return {
      prices,
      addPrice,
      openModal,
      savePrices,
      updatePrice,
      removePrice,
      EDIT_DMT_FEE_MODAL,
      CARRIER_PRIORITY_MODAL,
    }
  },
})
</script>
